<template>
  <div class="combo-import-page">
    <h2 class="combo-title">套餐单品对账</h2>
    <el-alert title="站点类型：一件代发商城。仅查询新套餐模块中当前身份可见的已支付订单；原账户及原订单级导出保持原样。" type="info" :closable="false" />
    <div class="combo-toolbar">
      <el-input v-model="batchSn" placeholder="批次号（选填）" clearable style="width: 270px" />
      <el-input v-model.number="caId" placeholder="新账单ID（选填，不是旧ca_id）" clearable style="width: 260px" />
      <el-button type="primary" :loading="loading" @click="load">查询</el-button>
      <el-button :disabled="!rows.length" @click="downloadSettlement(rows)">导出单品明细</el-button>
      <el-button @click="$router.push('/finance/site-finance')">原站点财务</el-button>
    </div>
    <el-table v-loading="loading" :data="rows" border size="small">
      <el-table-column prop="trade_sn" label="交易号" min-width="220" />
      <el-table-column prop="batch_sn" label="批次号" min-width="220" />
      <el-table-column label="类型/套餐" min-width="180"><template slot-scope="scope"><el-tag v-if="scope.row.shop_combo_id" type="warning">套餐</el-tag><el-tag v-else>普通</el-tag>{{ scope.row.shop_combo_name || '—' }}</template></el-table-column>
      <el-table-column prop="name" label="单品" min-width="180" />
      <el-table-column prop="sku_sn" label="单品编号" min-width="120" />
      <el-table-column prop="seller_name" label="供应商" min-width="140" />
      <el-table-column prop="num" label="数量" width="80" />
      <el-table-column label="店铺分摊" width="110"><template slot-scope="scope">¥{{ money(scope.row.shop_subtotal) }}</template></el-table-column>
      <el-table-column label="供应商金额" width="110"><template slot-scope="scope">¥{{ money(scope.row.supplier_subtotal) }}</template></el-table-column>
      <el-table-column label="已完成退款" width="110"><template slot-scope="scope">¥{{ money(scope.row.refund_amount) }}</template></el-table-column>
      <el-table-column label="售后未决" width="90"><template slot-scope="scope">{{ text(scope.row.after_sale_pending) }}</template></el-table-column>
      <el-table-column label="行净额" width="110"><template slot-scope="scope">¥{{ money(scope.row.line_net_amount) }}</template></el-table-column>
      <el-table-column label="订单运费" width="100"><template slot-scope="scope">¥{{ money(scope.row.freight_price) }}</template></el-table-column>
      <el-table-column prop="pay_status" label="支付状态" width="100" />
      <el-table-column label="发货状态" width="100"><template slot-scope="scope">{{ stateText(scope.row.shipment_status) }}</template></el-table-column>
    </el-table>
    <div v-if="!loading && !rows.length" class="combo-summary combo-muted">当前条件下没有明细；空账单不会退化为全量查询。</div>
  </div>
</template>
<script>
import { getComboSettlement, getComboBillSettlement } from '@/api/comboImport'
import { money, text, stateText, downloadSettlement, parseBillId } from './comboImportShared'

export default {
  name: 'ComboImportSettlement',
  data () { return { batchSn: '', caId: null, rows: [], loading: false, requestSeq: 0 } },
  methods: {
    money,
    text,
    stateText,
    downloadSettlement,
    async load () {
      const bill = parseBillId(this.caId)
      if (bill.provided && !bill.valid) {
        this.rows = []
        this.$message.warning('新账单ID必须为大于0的正整数；非法ID不会退化为全量查询')
        return
      }
      this.loading = true
      // 仅最新请求的响应允许写页面，过期响应不得覆盖当前筛选结果或loading
      const requestId = ++this.requestSeq
      try {
        const response = bill.provided
          ? await getComboBillSettlement(bill.value)
          : await getComboSettlement({ batch_sn: this.batchSn || undefined })
        if (requestId !== this.requestSeq) return
        this.rows = response.data || []
      } catch (e) {
        if (requestId !== this.requestSeq) return
        this.rows = []
        this.$message.error('查询失败，请稍后重试')
      } finally {
        if (requestId === this.requestSeq) this.loading = false
      }
    }
  }
}
</script>
<style src="./comboImport.css"></style>
